import {
  Menu,
  Tutorial,
  SinglePlayerBlitz,
  SinglePlayerEndless,
  MultiPlayerBlitz,
  MultiPlayerEndless,
  GameOver,
} from './delivery-guy';
export const gameData = {
  'delivery-guy': {
    type: window.Phaser?.AUTO,
    parent: 'game',
    width: 480,
    height: 590,
    pixelArt: false,
    scaleMode: 0,
    input: {
      gamepad: true,
    },
    physics: {
      default: 'arcade',
    },
    backgroundColor: 'rgba(0,0,0,0)',
    scene: [
      Menu,
      Tutorial,
      SinglePlayerEndless,
      SinglePlayerBlitz,
      MultiPlayerEndless,
      MultiPlayerBlitz,
      GameOver,
    ],
  },
};
